// components/TrafficInfo.tsx

'use client';
import { CarFront } from 'lucide-react';

export interface TrafficData {
  level: string | number | null;
  time: string | null;
  hint: string | null;
}

interface TrafficInfoProps {
  initialTraffic: TrafficData;
}

const getTrafficColorClass = (level: number): string => {
  if (level >= 8) return 'text-red-600';
  if (level >= 6) return 'text-red-400';
  if (level >= 4) return 'text-[color:var(--main)]';
  return 'text-green-400';
};

const getTrafficAccessibilityText = (level: number): string => {
  if (level >= 8) return 'Очень сильные пробки';
  if (level >= 6) return 'Есть пробки';
  if (level >= 4) return 'Движение затруднено';
  return 'Дороги свободны';
};

export default function TrafficInfo({ initialTraffic }: TrafficInfoProps) {
  const raw = initialTraffic.level;
  const level = raw === null || raw === undefined ? null : Number(raw);

  if (level === null || Number.isNaN(level)) return null;

  const levelClass = getTrafficColorClass(level);
  const a11y = getTrafficAccessibilityText(level);

  return (
    <div className="flex items-center gap-1" aria-label={`${a11y}. Уровень: ${level}`}>
      <CarFront className="h-4 w-4 text-yellow-400" aria-hidden="true" />
      <p>
        Пробки: <span className={`font-bold ${levelClass}`}>{level}</span>
      </p>
    </div>
  );
}
